import { EditButton, useRecordContext } from "react-admin"

export const InterimEditButtom = () => {
    const record = useRecordContext();
    if (record && record.animation) {
        return <EditButton label='Edit' resource="interims"/>;
    }
    return null; 
};